import React, { useState } from "react";
import {
  Modal,
  Descriptions,
  Image,
  Button,
  Form,
  message,
  Upload,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";

const BannerDetail = ({ visible, onClose, banner, onDelete, onUpdate }) => {
  const [editing, setEditing] = useState(false);
  const [form] = Form.useForm();
  const [imageBase64, setImageBase64] = useState(null); // dataURL (미리보기용)

  if (!banner) return null;

  const handleEdit = () => {
    setEditing(true);
    // 현재는 수정 가능한 다른 필드가 없으므로 form 초기값은 생략 가능
    form.setFieldsValue({});
  };

  const handleCancelEdit = () => {
    setEditing(false);
    setImageBase64(null);
    form.resetFields();
  };

  const handleUpdate = async () => {
    try {
      await form.validateFields(); // 필요 시 유효성 검사
      const payload = {
        id: banner.id,
        // 새 이미지를 선택했다면 base64 본문만, 아니면 기존 URL 그대로
        image_img:
          imageBase64 === null
            ? banner.image_img
            : imageBase64.split(",")[1],
      };
      onUpdate(payload);
      setEditing(false);
      setImageBase64(null);
    } catch (error) {
      console.error(error);
      message.error("수정에 실패했습니다. 입력 값을 확인해주세요.");
    }
  };

  const handleImageChange = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setImageBase64(e.target.result); // e.g. "data:image/png;base64,AAAA..."
    };
    reader.readAsDataURL(file);
  };

  return (
    <Modal
      title="배너 상세 정보"
      visible={visible}  /* antd v5면 open={visible} 로 변경 */
      onCancel={onClose}
      footer={null}
      width={800}
    >
      {!editing ? (
        <>
          <Descriptions bordered column={2} size="middle">
            <Descriptions.Item label="생성일자">
              {banner.created_at}
            </Descriptions.Item>
            <Descriptions.Item label="업데이트일자">
              {banner.updated_at}
            </Descriptions.Item>
            <Descriptions.Item label="이미지" span={2}>
              <Image src={banner.image_img} alt="배너 이미지" width={300} />
            </Descriptions.Item>
          </Descriptions>
          <div style={{ marginTop: 20, textAlign: "right" }}>
            <Button
              type="primary"
              onClick={handleEdit}
              style={{ marginRight: 8 }}
            >
              수정
            </Button>
            {/* 삭제 버튼 필요하면 활성화
            <Button danger onClick={() => onDelete?.(banner.id)} style={{ marginRight: 8 }}>
              삭제
            </Button>
            */}
            <Button onClick={onClose}>닫기</Button>
          </div>
        </>
      ) : (
        <Form form={form} layout="vertical" initialValues={{}}>
          <Form.Item label="이미지 업로드">
            <Upload
              accept="image/*"
              beforeUpload={(file) => {
                handleImageChange(file);
                return false; // 서버로 자동 업로드 막기
              }}
              showUploadList={false}
            >
              <Button icon={<UploadOutlined />}>이미지 선택</Button>
            </Upload>

            {/* 미리보기: 새 선택이 있으면 그걸, 없으면 기존 이미지 */}
            <Image
              src={imageBase64 ?? banner.image_img}
              alt="업로드 미리보기"
              width={300}
              style={{ display: "block", marginTop: 10 }}
            />
          </Form.Item>

          <div style={{ textAlign: "right", marginTop: 20 }}>
            <Button type="primary" onClick={handleUpdate} style={{ marginRight: 8 }}>
              저장
            </Button>
            <Button onClick={handleCancelEdit}>취소</Button>
          </div>
        </Form>
      )}
    </Modal>
  );
};

export default BannerDetail;
